import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentApi } from '../services/api';
import toast from 'react-hot-toast';

const PaymentResult: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'failed' | 'pending'>('loading');
  const [orderInfo, setOrderInfo] = useState<any>(null);

  useEffect(() => {
    const checkOrder = async () => {
      // 从URL获取参数
      const outTradeNo = searchParams.get('out_trade_no');
      const tradeStatus = searchParams.get('trade_status');
      const tradeNo = searchParams.get('trade_no');

      if (!outTradeNo) {
        setStatus('failed');
        return;
      }

      try {
        // 如果支付平台返回成功状态，先调用同步接口
        if (tradeStatus === 'TRADE_SUCCESS' && tradeNo) {
          await paymentApi.syncOrder(outTradeNo, tradeNo);
        }

        // 查询订单状态
        const result = await paymentApi.getOrder(outTradeNo, true);
        
        if (result.success && result.data) {
          setOrderInfo(result.data);
          if (result.data.status === 'paid') {
            setStatus('success');
            toast.success('支付成功！');
          } else if (result.data.status === 'pending') {
            setStatus('pending');
          } else {
            setStatus('failed');
          }
        } else {
          setStatus('failed');
        }
      } catch (error) {
        console.error('查询订单失败:', error);
        setStatus('failed');
      }
    };

    checkOrder();
  }, [searchParams]);

  const handleGoBack = () => {
    if (orderInfo?.item_type === 'agent') {
      navigate('/agent-market');
    } else {
      navigate('/plaza');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-20 pb-12">
      <div className="container mx-auto px-4 max-w-md">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 text-center">
          {status === 'loading' && (
            <>
              <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                正在查询支付结果...
              </h2>
              <p className="text-gray-500 dark:text-gray-400">请稍候</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-check text-4xl text-green-500"></i>
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                支付成功！
              </h2>
              <p className="text-gray-500 dark:text-gray-400 mb-6">
                {orderInfo?.item_name || '商品'} 已解锁
              </p>
              <button
                onClick={handleGoBack}
                className="w-full py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl font-medium hover:shadow-lg transition-all"
              >
                返回继续浏览
              </button>
            </>
          )}

          {status === 'pending' && (
            <>
              <div className="w-20 h-20 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-clock text-4xl text-yellow-500"></i>
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                等待支付确认
              </h2>
              <p className="text-gray-500 dark:text-gray-400 mb-6">
                支付结果正在处理中，请稍后刷新页面查看
              </p>
              <div className="space-y-3">
                <button
                  onClick={() => window.location.reload()}
                  className="w-full py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl font-medium hover:shadow-lg transition-all"
                >
                  <i className="fas fa-sync mr-2"></i>
                  刷新状态
                </button>
                <button
                  onClick={handleGoBack}
                  className="w-full py-3 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-all"
                >
                  返回
                </button>
              </div>
            </>
          )}

          {status === 'failed' && (
            <>
              <div className="w-20 h-20 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-times text-4xl text-red-500"></i>
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                支付失败
              </h2>
              <p className="text-gray-500 dark:text-gray-400 mb-6">
                订单未找到或支付未成功
              </p>
              <button
                onClick={handleGoBack}
                className="w-full py-3 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-all"
              >
                返回
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentResult;

